// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function AntDesigninstagramOutlined2Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 18 18"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M9.375.75c-2.238 0-2.52.01-3.4.05-.88.04-1.478.179-2.003.383a4.04 4.04 0 00-1.462.952 4.05 4.05 0 00-.951 1.461c-.205.524-.344 1.124-.384 2-.04.883-.05 1.163-.05 3.405 0 2.24.01 2.52.05 3.4.041.879.18 1.478.384 2.003.211.542.492 1.002.951 1.461.458.459.918.742 1.46.952.527.204 1.125.343 2.003.384.881.039 1.162.049 3.402.049 2.241 0 2.52-.01 3.402-.05.877-.04 1.478-.179 2.003-.383a4.04 4.04 0 001.46-.952c.46-.459.74-.919.952-1.461.203-.525.343-1.124.384-2.003.04-.88.05-1.16.05-3.401 0-2.24-.01-2.521-.05-3.402-.041-.878-.18-1.478-.384-2.002a4.05 4.05 0 00-.951-1.461 4.034 4.034 0 00-1.462-.952C14.253.98 13.653.84 12.775.8c-.88-.04-1.16-.05-3.402-.05h.003zm-.739 1.487h.74c2.203 0 2.464.007 3.334.048.804.036 1.241.17 1.532.283.384.15.66.33.949.618.288.289.467.563.616.949.114.29.248.727.284 1.531.04.87.048 1.13.048 3.332s-.008 2.464-.048 3.333c-.036.804-.171 1.24-.284 1.531a2.546 2.546 0 01-.617.948 2.55 2.55 0 01-.95.617c-.288.113-.725.247-1.53.284-.87.04-1.13.049-3.334.049-2.202 0-2.464-.01-3.334-.049-.804-.037-1.24-.17-1.531-.284a2.555 2.555 0 01-.949-.617 2.557 2.557 0 01-.618-.949c-.113-.29-.248-.727-.284-1.531-.04-.87-.048-1.13-.048-3.334 0-2.203.009-2.463.048-3.332.037-.804.171-1.242.285-1.533.15-.384.329-.66.617-.948.289-.289.563-.467.949-.617.29-.113.727-.247 1.531-.285.761-.035 1.056-.045 2.594-.046v.002zm5.144 1.37a.99.99 0 100 1.98.99.99 0 000-1.98zM9.376 4.764a4.238 4.238 0 10-.132 8.474 4.238 4.238 0 00.132-8.474zm0 1.486a2.75 2.75 0 110 5.5 2.75 2.75 0 010-5.5z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default AntDesigninstagramOutlined2Icon
/* prettier-ignore-end */
